export default "__VITE_ASSET__VHQHOyMh__"